import * as tslib_1 from "tslib";
import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';
import Tooltip from "../Tooltip";
import AccordionHeading from './AccordionHeading';
import svgCaretDown from "../../../../svg-icons/nx-caret-down.svg";
import "./AccordionItem.css";

var AccordionItem =
/** @class */
function (_super) {
  tslib_1.__extends(AccordionItem, _super);

  function AccordionItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleItemToggleRequest = function (event) {
      var _a = _this.props,
          id = _a.id,
          _b = _a.value,
          value = _b === void 0 ? {} : _b,
          onItemToggleRequest = _a.onItemToggleRequest;
      onItemToggleRequest(event, {
        id: id,
        value: value
      });
    };

    _this.handleToushStart = function (e) {
      return e.nativeEvent.stopImmediatePropagation();
    };

    return _this;
  }

  AccordionItem.prototype.render = function () {
    var _a;

    var _b = this.props,
        blockName = _b.blockName,
        className = _b.className,
        id = _b.id,
        label = _b.label,
        isOpen = _b.isOpen,
        wideDecorate = _b.wideDecorate,
        hideBar = _b.hideBar,
        labelIcon = _b.labelIcon,
        expandIcon = _b.expandIcon,
        a11yId = _b.a11yId,
        children = _b.children,
        tooltipMessage = _b.tooltipMessage,
        tooltipOptions = _b.tooltipOptions;
    var finalClassName = cx(blockName, (_a = {}, _a[blockName + "--open"] = isOpen, _a), className);
    var mainClassName = wideDecorate ? blockName + "__main-wide" : blockName + "__main";
    var contentClassName = hideBar ? blockName + "__content" : blockName + "__content-bar";
    var finalExpandIcon = null;

    if (expandIcon) {
      var expandIconClassName = cx(expandIcon.props.className, blockName + "__arrow");
      finalExpandIcon = cloneElement(expandIcon, {
        className: expandIconClassName,
        role: 'presentation'
      });
    }

    var uid = a11yId ? blockName + "-" + a11yId + "-" + id : "" + id;
    var heading = React.createElement("dt", {
      role: "heading"
    }, React.createElement(AccordionHeading, {
      onClick: this.handleItemToggleRequest,
      "aria-controls": uid,
      href: undefined,
      tabIndex: 0
    }, !!labelIcon && React.createElement("div", {
      className: blockName + "__label-icon"
    }, labelIcon), React.createElement("div", {
      className: blockName + "__label"
    }, label), finalExpandIcon && React.createElement("div", {
      className: blockName + "__arrow-wrapper"
    }, finalExpandIcon)));
    return React.createElement("div", {
      className: finalClassName,
      onTouchStart: this.handleToushStart
    }, React.createElement("div", {
      className: mainClassName
    }, tooltipMessage ? React.createElement(Tooltip, tslib_1.__assign({}, tooltipOptions, {
      text: tooltipMessage,
      targetClassName: blockName + "__tooltip-target"
    }), heading) : heading, React.createElement("dd", {
      className: contentClassName,
      role: "region",
      "aria-expanded": isOpen,
      "aria-hidden": !isOpen,
      id: uid
    }, isOpen && children)));
  };

  AccordionItem.propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    a11yId: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.node,
    labelIcon: PropTypes.node,
    isOpen: PropTypes.bool,
    wideDecorate: PropTypes.bool,
    hideBar: PropTypes.bool,
    onItemToggleRequest: PropTypes.func,
    expandIcon: PropTypes.node,
    children: PropTypes.node,
    tooltipMessage: PropTypes.string,
    tooltipOptions: PropTypes.object
  };
  AccordionItem.defaultProps = {
    blockName: 'nx-accordion-item',
    onItemToggleRequest: noop,
    wideDecorate: false,
    hideBar: false,
    isOpen: false,
    expandIcon: React.createElement("img", {
      className: "nx-accordion__expand-icon",
      alt: "",
      src: svgCaretDown
    }),
    tooltipOptions: {}
  };
  return AccordionItem;
}(Component);

export default AccordionItem;

try {
  // @ts-ignore
  AccordionItem.__docgenInfo = {
    "description": "",
    "displayName": "AccordionItem",
    "props": {
      "blockName": {
        "defaultValue": {
          value: "nx-accordion-item"
        },
        "description": "",
        "name": "blockName",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "hideBar": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "hideBar",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "value": {
        "defaultValue": null,
        "description": "",
        "name": "value",
        "required": true,
        "type": {
          "name": "T"
        }
      },
      "label": {
        "defaultValue": null,
        "description": "",
        "name": "label",
        "required": true,
        "type": {
          "name": "ReactChild"
        }
      },
      "id": {
        "defaultValue": null,
        "description": "",
        "name": "id",
        "required": true,
        "type": {
          "name": "string | number | undefined"
        }
      },
      "labelIcon": {
        "defaultValue": null,
        "description": "",
        "name": "labelIcon",
        "required": false,
        "type": {
          "name": "ReactNode"
        }
      },
      "a11yId": {
        "defaultValue": null,
        "description": "",
        "name": "a11yId",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "expandIcon": {
        "defaultValue": null,
        "description": "",
        "name": "expandIcon",
        "required": true,
        "type": {
          "name": "ReactElement<{ className?: string | undefined; role?: string | undefined; }>"
        }
      },
      "wideDecorate": {
        "defaultValue": {
          value: "false"
        },
        "description": "",
        "name": "wideDecorate",
        "required": true,
        "type": {
          "name": "boolean"
        }
      },
      "tooltipMessage": {
        "defaultValue": null,
        "description": "",
        "name": "tooltipMessage",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "tooltipOptions": {
        "defaultValue": {
          value: "{}"
        },
        "description": "",
        "name": "tooltipOptions",
        "required": false,
        "type": {
          "name": "Pick<Pick<MergePropTypes<Props, InferProps<{ disabled: Requireable<boolean>; text: Validator<any>; children: Requireable<ReactNodeLike>; className: Requireable<string>; style: Requireable<object>; ... 12 more ...; targetComponent: Requireable<...>; }>>, \"className\" | ... 8 more ... | \"style\"> & Partial<...> & Partia..."
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}